import React, { memo } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, oneOf } from 'prop-types'

import { LIBRARY_TAB } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const TEXT_KEY_BY_TAB = {
  [LIBRARY_TAB.MODELS]: 'sidebar.library.emptyState.text',
  [LIBRARY_TAB.IMAGES]: 'sidebar.library.emptyState.imagesText',
}

const ACTION_KEY_BY_TAB = {
  [LIBRARY_TAB.MODELS]: 'sidebar.actions.generateNewModel',
  [LIBRARY_TAB.IMAGES]: 'sidebar.actions.generateNewImage',
}

function EmptyState({ tab = LIBRARY_TAB.MODELS, onGenerate = null }) {
  const t = useTranslation()

  return (
    <div className="empty-state">
      <p className="empty-state__text cgt-body-base-semibold">
        {t(TEXT_KEY_BY_TAB[tab])}
      </p>
      {onGenerate && (
        <Button
          type="secondary"
          size="tiny"
          actionType="button"
          customClass="empty-state__button"
          onClick={onGenerate}
        >
          {t(ACTION_KEY_BY_TAB[tab])}
        </Button>
      )}
    </div>
  )
}

EmptyState.propTypes = {
  tab: oneOf(Object.values(LIBRARY_TAB)),
  onGenerate: func,
}

export default memo(EmptyState)
